import React, { useEffect } from 'react'
import classNames from 'classnames'
import gridClasses from '../../../styles/grid.module.css'
import classes from './PurchaseHistory.module.css'
import { AuthenticatedHeader } from '../../../components/Header/AuthenticatedHeader'
import { PurchaseHistoryTable } from '../../../components/Tables/PurchaseHistoryTable'
import { useDispatch, useSelector } from 'react-redux'
import { purchaseHistorySelectors } from './purchaseHistorySlice'
import { userSelectors } from '../../../redux/userSlice'
import { getPurchaseHistory } from './purchaseHistoryApi'
import notification from '../../../components/Notification/notification'

export const PurchaseHistoryPage = () => {
    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    useEffect(() => {
        dispatch(getPurchaseHistory(user.email))
    }, [])

    const isFetching = useSelector(purchaseHistorySelectors.isFetching)
    const hasError = useSelector(purchaseHistorySelectors.hasError)
    const errorMessage = useSelector(purchaseHistorySelectors.errorMessage)
    const history = useSelector(purchaseHistorySelectors.history)

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    return (
        <React.Fragment>
            <AuthenticatedHeader />
            <div className={classes.topBar}>
                <div
                    className={classNames(
                        gridClasses.container,
                        gridClasses.containerTransparent
                    )}
                >
                    <h1 className={classes.topBarTitle}>Purchase History</h1>
                </div>
            </div>
            <main
                className={classNames(
                    gridClasses.container,
                    classes.pageContent
                )}
            >
                <PurchaseHistoryTable items={history} loading={isFetching} />
            </main>
        </React.Fragment>
    )
}
